import { render, staticRenderFns } from "./filter-search.vue?vue&type=template&id=872d937a&"
import script from "./filter-search.vue?vue&type=script&lang=js&"
export * from "./filter-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/filter-search/filter-search.vue
// module id = 142
// module chunks = 0